import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponentDirective, MenuService, WpMenuDataItem } from '@streamamg/amg-common';
import { WpCommonData, WpFooter, WpSponsor } from '../../types/wordpress/common-data.type';
import Flickity from 'flickity';
import { WpFooterSocialMenu } from './footer.type';
import { combineLatest } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { selectTeams } from '../../store/teams/teams.selectors';
import { Team } from '../../services/cebl.api.types';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent extends BaseComponentDirective implements OnInit {
  @Input() wpCommonData: WpCommonData;

  public viewModel: WpFooter;
  public teams: Team[];
  public socialMenu: WpFooterSocialMenu;
  public footerNavigation: WpMenuDataItem[];
  public footerBottomLinks: WpMenuDataItem[];

  public sponsors: WpSponsor[][];
  public partners: WpSponsor[][];
  public sponsorOptions: Flickity.Options;
  public partnerOptions: Flickity.Options;

  constructor(
    private cd: ChangeDetectorRef,
    private menuService: MenuService,
    private store: Store<AppState>,
  ) {
    super();

    this.sponsorOptions = {
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
    };

    this.partnerOptions = {...this.sponsorOptions};
  }

  ngOnInit(): void {
    this.viewModel = this.wpCommonData?.footer;

    const sponsors = this.viewModel?.sponsors?.sponsors;
    this.sponsors = this.splitSponsorsIntoPanes(sponsors);
    this.sponsorOptions.pageDots = (this.sponsors.length > 1);

    const partners = this.viewModel?.partners?.sponsors;
    this.partners = this.splitSponsorsIntoPanes(partners);
    this.partnerOptions.pageDots = (this.partners.length > 1);

    this.cd.detectChanges();

    super.subSink = combineLatest([
      this.store.select(selectTeams),
      this.menuService.getMenuDataItems('social'),
      this.menuService.getMenuDataItems('footer'),
      this.menuService.getMenuDataItems('footer-bottom'),

    ]).subscribe(([
                    teams,
                    socialMenu,
                    footerNavigation,
                    bottomLinks,
                  ]) => {

      this.teams = teams;

      if (socialMenu) {
        this.socialMenu = socialMenu as WpFooterSocialMenu;
      }
      if (footerNavigation) {
        this.footerNavigation = footerNavigation.items;
      }
      if (bottomLinks) {
        this.footerBottomLinks = bottomLinks.items;
      }

      this.cd.markForCheck();
    });
  }

  private splitSponsorsIntoPanes(sponsors: WpSponsor[] = []): WpSponsor[][] {
    const toReturn: WpSponsor[][] = [];

    sponsors?.forEach((sponsor: WpSponsor, j: number) => {
      const i = Math.floor(j / 6);
      if (!toReturn[i]) {
        toReturn[i] = [];
      }

      toReturn[i].push(sponsor);
    });

    return toReturn;
  }


  public getTeam(teamSlug: string): Team {

    return this.teams.find((team) => team.wpTeam.post_slug === teamSlug);
  }
}
